/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * PaperclipIcon
 */
export default class PaperclipIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M13.85 2.75c1.834-1.84 4.914-2.14 7.084-.593 2.26 1.61 2.546 4.672 1.399 6.397-.678 1.019-3.834 4.84-9.57 11.593a1 1 0 01-1.525-1.294c5.642-6.643 8.819-10.489 9.43-11.407.588-.884.415-2.728-.894-3.66-1.365-.973-3.356-.779-4.508.376C13.686 5.744 4.16 16.777 3.314 18.049c-.596.896-.427 1.826.358 2.613.576.576 1.874.576 2.449 0 .277-.278 5.166-6.105 6.618-7.81l.177-.213c2.03-2.44 2.288-2.815 2.257-3.017a.672.672 0 00-.067-.175.554.554 0 00-.921-.107l-4.417 5.3a1 1 0 11-1.536-1.28l4.416-5.3a2.554 2.554 0 014.246.493c.131.261.217.508.257.77.171 1.132.084 1.257-2.883 4.817a1.025 1.025 0 01-.004.006c-1.336 1.569-6.379 7.58-6.727 7.928-1.357 1.36-3.924 1.36-5.28 0-1.416-1.418-1.772-3.383-.608-5.133.93-1.399 10.537-12.524 12.2-14.192z" fillRule="nonzero"/></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

